import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { LoanSuggestedTermService } from '../../../service/rbi-compliance/loan-suggested-term.service';
import { LOAN_SUGGESTED_TERM, LoanSuggestedTerm, UserSuggestedTerm } from '../../../model/rbi-compliance/loan-suggested-term.model';
import { first, map } from 'lodash';
import { SuggestedLoansTermsTable } from './loan-suggested-term-table.model';
import { Toaster, Type } from '../../../toaster/Toaster';
import { LoanSuggestedTermPopUpComponent } from '../../../shared/loan-suggested-term-pop-up/loan-suggested-term-pop-up.component';

@Component({
  selector: 'app-loan-suggested-term-table',
  templateUrl: './loan-suggested-term-table.component.html',
  styleUrls: ['./loan-suggested-term-table.component.css']
})
export class LoanSuggestedTermTableComponent implements OnInit {

  private userId: string;
  public loanSuggestedTerm: LoanSuggestedTerm;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly dialog: MatDialog,
    private readonly loanSuggestedTermService: LoanSuggestedTermService) {
    this.activatedRoute.data.subscribe(data => {
      this.userId = data.userId;
    });
    console.log("STARTED ", this.userId);
  }

  ngOnInit(): void {
    console.log("working", this.dataSource);
    this.getLoanSuggestedTerm();
  }

  displayedColumns: string[] = [
    "generatedLoanId",
    "name",
    "loanAmount",
    "indicatedLoanRate",
    "indicatedLoanTenure",
    "lenderSuggestedRate",
    "lenderSuggestedTenure",
    "borrowerStatus",
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  data: any;
  dataSource: MatTableDataSource<SuggestedLoansTermsTable>;

  ngAfterViewInit() {
  }

  public getLoanSuggestedTerm() {
    this.dataSource = new MatTableDataSource([]);
    this.loanSuggestedTermService.getLoanSuggestedTermByBorrowerProfileId(this.userId)
      .then((res) => {
        if (res[0]) {
          this.loanSuggestedTerm = first(res);
          const suggestedLoansTermsTable: SuggestedLoansTermsTable[] = map(this.loanSuggestedTerm.userSuggestedTerms, (obj, key) => {
            return new SuggestedLoansTermsTable(
              obj._id,
              obj.borrowerStatus,
              obj.borrowerSuggestedRate,
              obj.borrowerSuggestedTenure,
              obj.comment,
              obj.createdAt,
              obj.investedAmount,
              obj.lenderId,
              obj.lenderStatus,
              obj.lenderSuggestedRate,
              obj.lenderSuggestedTenure,
              obj.name,
              obj.updatedAt,
              this.loanSuggestedTerm.generatedLoanId,
              this.loanSuggestedTerm.loanAmount,
              this.loanSuggestedTerm.roi,
              this.loanSuggestedTerm.loanTenure
            )
          })

          this.dataSource = new MatTableDataSource(suggestedLoansTermsTable);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;

          console.log(suggestedLoansTermsTable)

        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  public investmentNegotiationHandler(loan: object, borrowerDetail: object, loanSuggestedTerm: LoanSuggestedTerm) {
    const matDialogConfig: MatDialogConfig = {
      maxHeight: '90vh',
      width: '80%',
      panelClass: 'dialog-responsive',
      data: {
        loan: loan,
        borrowerDetail: borrowerDetail,
        loanSuggestedTerm: loanSuggestedTerm,
        isBorrower: true,
      }
    };
    this.dialog.open(LoanSuggestedTermPopUpComponent, matDialogConfig).afterClosed().subscribe((res) => {
    });
  }

  actionButtonHandler(type: string, row: UserSuggestedTerm) {
    if (type === LOAN_SUGGESTED_TERM.ACCEPTED) {
      const userSuggestedTerm: UserSuggestedTerm = { ...row, borrowerStatus: LOAN_SUGGESTED_TERM.ACCEPTED };
      this.updateLoanSuggestedTerm(this.loanSuggestedTerm._id, userSuggestedTerm);
    } else if (type === LOAN_SUGGESTED_TERM.REJECTED) {
      const userSuggestedTerm: UserSuggestedTerm = { ...row, borrowerStatus: LOAN_SUGGESTED_TERM.REJECTED };
      this.updateLoanSuggestedTerm(this.loanSuggestedTerm._id, userSuggestedTerm);
    } else {
      const loan: any = {
        loanId: this.loanSuggestedTerm.loanId,
        loanShortId: this.loanSuggestedTerm.generatedLoanId,
        loanAmount: this.loanSuggestedTerm.loanAmount,
        tenure: this.loanSuggestedTerm.loanTenure,
        finzyRating: this.loanSuggestedTerm.rating,
        loanStatus: this.loanSuggestedTerm.loanSanctionStatus,
        investmentAmount: row.investedAmount,
        borrowerId: this.loanSuggestedTerm.profile,
      };
      const borrowerDetail: any = { name: this.loanSuggestedTerm.name };
      this.loanSuggestedTerm.userSuggestedTerms[0].borrowerStatus = LOAN_SUGGESTED_TERM.MODIFIED;
      const loanSuggestedTermForSelectedLender: LoanSuggestedTerm = LoanSuggestedTerm.createFrom(this.loanSuggestedTerm);
      loanSuggestedTermForSelectedLender.userSuggestedTerms = [{...row}];
      this.investmentNegotiationHandler(loan, borrowerDetail, loanSuggestedTermForSelectedLender);
    }
  }

  public updateLoanSuggestedTerm(id: string, userSuggestedTerm: UserSuggestedTerm) {
    this.loanSuggestedTermService.updateLoanSuggestedTerm(id, userSuggestedTerm)
      .then((res) => {
        Toaster.toast('Updated Loan Terms Suggestion', Type.Success);
        this.getLoanSuggestedTerm();
      })
      .catch((error) => {
        console.log('ERROR ', error);
      })
  }

}
